import { render } from "./EventList.vue?vue&type=template&id=49e04ade&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=49e04ade&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-49e04ade"

export default script